// extracted by mini-css-extract-plugin
module.exports = {"select":"InsightsViaEmail-editor_select__1mCk-","buttons":"InsightsViaEmail-editor_buttons__27GQs"};